import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login");
            return;
        }
        const sessionId = decodeURIComponent(match[1]);

        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                setUser(data.user);
                // Clean hash and go to dashboard
                window.history.replaceState({}, "", "/dashboard");
                toast.success("Signed in with Google");
                navigate("/dashboard", { state: { user: data.user }, replace: true });
            } catch (e) {
                toast.error("Google sign-in failed");
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-[60vh] flex items-center justify-center">
            <div className="flex items-center gap-3 text-muted-foreground">
                <span className="pulse-dot w-2 h-2 rounded-full bg-primary" />
                <span className="text-sm">Completing sign-in…</span>
            </div>
        </div>
    );
}
